import styled from "styled-components";

export const SidebarContainer = styled.div`
  width: clamp(220px, 15vw, 300px);
  padding: 64px 32px;
  position: fixed;
  height: 100vh;
  background: #fff;
  border-right: 1px solid #000;
  transition: transform 0.3s ease-in-out;
  transform: translateX(0);
  z-index: 2000;
  

  @media (max-width: 768px) {
    max-width: 240px;
    transition: width 0.3s ease-in-out;
    transform: ${({ open }) =>
    open ? "translateX(0)" : "translateX(-100%)"};
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;


export const Logo = styled.h1`
  font-size: 24px;
  line-height: 1.2;
  margin-bottom: 40px;
  text-transform: uppercase;
`;

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const NavItem = styled.a`
  font-size: 18px;
  text-transform: uppercase;
  text-decoration: none;
  color: #000;

  &:hover {
    text-decoration: underline;
  }
`;

/* Hamburger menu button: hidden on desktop, shown on mobile */
export const HamburgerMenu = styled.button`
  position: fixed;
  top: 20px;
  left: 20px;
  width: 32px;
  height: 24px;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 2200;

  span {
    display: block;
    height: 3px;
    background: #000;
    border-radius: 2px;
    transition: all 0.3s ease-in-out;
    transform-origin: center;
  }

  ${({ open }) =>
    open &&
    `
    span:nth-child(1) {
      transform: rotate(45deg) translate(0, 10px);
    }
    span:nth-child(2) { 
      opacity: 0;
    } 
    span:nth-child(3) { 
      transform: rotate(-45deg) translate(0, -10px); 
    }
  `}

  @media (max-width: 768px) {
    display: flex;
  }
`;

/* Overlay behind sidebar when open on mobile */
export const Overlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: ${props => (props.open ? "block" : "none")};
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1500;
  }
`;

